import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('radios', { params }).then(result => result.data)
  },
  get(id) {
    return axios.get(`radios/${id}`).then(result => result.data)
  },
  fetchClocks(radioId) {
    return axios.get(`radios/${radioId}/clocks`).then(result => result.data)
  },
  storeClock(radioId, data) {
    return axios.post(`radios/${radioId}/clocks`, data).then(result => result.data)
  },
  updateClock(radioId, clockId, data) {
    return axios.patch(`radios/${radioId}/clocks/${clockId}`, data).then(result => result.data)
  },
  deleteClock(radioId, clockId) {
    return axios.delete(`radios/${radioId}/clocks/${clockId}`).then(result => result.data)
  },
  update(radioId, data) {
    return axios.patch(`radios/${radioId}`, data).then(result => result.data)
  },
  store(data) {
    return axios.post('radios', data).then(result => result.data)
  },
  delete(id) {
    return axios.delete(`radios/${id}`).then(result => result.data)
  },
  clone(id, data) {
    return axios.post(`radios/${id}/clone`, data).then(result => result.data)
  },
  toggleDisabled(radioId, clockId) {
    return axios.post(`radios/${radioId}/clocks/${clockId}/toggle-disabled`).then(result => result.data)
  },
  syncPlayers(radioId) {
    return axios.get(`radios/${radioId}/sync-players`)
  }
}
